import { Scene, Choice } from "../models";
import { scenes } from "../scenes";

export class BurgerJoint extends Scene {
  async init() {
    this.image = require("@/images/Vincent_Burger_Joint.png");
    this.title = "The Burger Joint";
    this.audio = null;
    this.description = "";
  }

  get options() {
    return [
      new Choice("Enter Burger Joint", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description = "SONNY YANG: I need to find that SANITIZER!";
          this.audio = require("@/audio/Pandemic-182-Sonny-MP3.mp3")

        } else {
          await this.navigate(scenes.InsideBurgerJoint());
        }
      }),
      new Choice("Go Left", async () => await this.navigate(scenes.GlennsHouseExterior())),
      new Choice("Go Right", async () => await this.navigate(scenes.HospitalExterior())),
    ];
  }
}

export default new BurgerJoint();
